import { motion } from 'framer-motion';

export const MeditatingYogi = () => {
  return (
    <motion.div
      className="relative w-full h-full"
      initial={{ scale: 0.9 }}
      animate={{
        scale: [0.9, 1.1, 0.9],
      }}
      transition={{
        duration: 4,
        repeat: Infinity,
        ease: "easeInOut"
      }}
      aria-label="मेडिटेटिंग योगी"
    >
      {/* Center Circle */}
      <div className="absolute inset-0 bg-white rounded-full shadow-lg" />
      
      {/* Glowing Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-full animate-pulse" />
      
      {/* Yogi Image */}
      <motion.img
        src="https://www.bhaktisarovar.in/disha-shool/disha-shool.png"
        alt="Meditating Yogi"
        className="relative w-full h-full object-cover rounded-full z-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      />
      
      {/* Meditation Aura */}
      <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-full -z-10 animate-pulse" />
    </motion.div>
  );
};